import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiHelpCircleOutline } from "@mdi/js";
import "./howItWorksButton.css";

/**
 * Consistent "How It Works" button used across pages.
 * Shows full button on desktop, icon-only on mobile.
 *
 * @param {function} onClick - Called when the button is clicked
 */
const HowItWorksButton = ({ onClick }) => {
  return (
    <>
      {/* Desktop: Full button with icon + text */}
      <Button
        variant="outline-primary"
        className="how-it-works-btn d-none d-md-inline-flex"
        onClick={onClick}
      >
        <Icon path={mdiHelpCircleOutline} size={1} />
        How It Works
      </Button>

      {/* Mobile: Icon-only button */}
      <button
        className="how-it-works-icon-btn d-md-none"
        onClick={onClick}
        aria-label="How It Works"
      >
        <Icon path={mdiHelpCircleOutline} size={1} />
      </button>
    </>
  );
};

export default HowItWorksButton;
